import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agency-one-pricing',
  templateUrl: './agency-one-pricing.component.html',
  styleUrls: ['./agency-one-pricing.component.scss']
})
export class AgencyOnePricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
